// Legacy new-agent URL — moved to `/agents/new` with the unified Agents
// page (2026-07 nav review).
import { createFileRoute, redirect } from '@tanstack/react-router';

import { routes } from '../../../lib/constants';

export const Route = createFileRoute('/workflows/agents/new')({
  beforeLoad: () => {
    throw redirect({ to: routes.AGENTS_NEW, replace: true });
  },
  component: () => null,
});
